import React from "react";
import { Route, Routes } from "react-router-dom";
// Components and pages
import NavBar from "./Components/NavBar/Nav";
import Footer from "./Components/Footer";
import EachGallery from "./Pages/EachGallery";
import Event from "./Pages/Event";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Committee from "./Pages/Committee";
import Gallery from "./Pages/Gallery";
import Activities from "./Pages/Activities";
import SearchResult from "Pages/SearchResult";
// import AdminLogin from "Pages/AdminLogin";
// import AdminDashboard from "Pages/AdminDashboard";

function App() {
  return (
    <div className="App text-sm md:text-base lg:text-lg xl:text-xl ">
      <NavBar />
      <main id="page-wrap" className="md:pt-48 mx-auto">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/about" element={<About />} />
          <Route path="/committee" element={<Committee />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:galleryID" element={<EachGallery />} />
          <Route path="/event/:eventID" element={<Event />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/search/:input" element={<SearchResult />} />

          {/* <Route path="/admin" element={<AdminLogin />} />
          <Route path="/dashboard" element={<AdminDashboard />} /> */}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
